import { render, staticRenderFns } from "./NbaPlayerTrends.vue?vue&type=template&id=21c630c3&scoped=true"
import script from "./NbaPlayerTrends.vue?vue&type=script&lang=js"
export * from "./NbaPlayerTrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c630c3",
  null
  
)

export default component.exports